<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallNumChartsList></CallNumChartsList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../../layouts/BasicLayout';
  import CallNumChartsList from '../../../../components/tsConfig/hytalkPro/system/CallNumChartsList';

  export default {
    name: 'SystemCallNumCharts',
    components: {
      BasicLayout,
      CallNumChartsList
    },
    data() {
      return {
        left: {
          show: false,
          name: ''
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: '111/22222/33333'
        }
      };
    }
  };
</script>

<style scoped>

</style>
